var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._g(
      _vm._b({ staticClass: "exception" }, "div", _vm.$attrs, false),
      _vm.$listeners
    ),
    [
      _c("div", { staticClass: "img-block" }, [
        _c("div", {
          staticClass: "img-ele",
          style: {
            backgroundImage:
              "url(" + (_vm.img || _vm.config[_vm.pageType].img) + ")",
          },
        }),
      ]),
      _c("div", { staticClass: "content" }, [
        _c("h1", [_vm._v(_vm._s(_vm.title || _vm.config[_vm.pageType].title))]),
        _c("div", { staticClass: "desc" }, [
          _vm._v(_vm._s(_vm.desc || _vm.config[_vm.pageType].desc)),
        ]),
        _c(
          "div",
          { staticClass: "actions" },
          [
            _vm.$slots.actions ? _vm._t("actions") : _vm._e(),
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.goHome } },
              [_vm._v("返回首页")]
            ),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }